<div class="confirm-container">
    <mat-card class="confirm-card-container">
        <mat-card-content>
            <div class="confirm-title-container">
                <span>
                    If there is any other insurance, this form is required in order for us to process your claims accurately. If you have any additional
                    questions regarding this questionnaire or if the information below changes, please contact the number found on the back of your identification
                    card. We appreciate your prompt reply.
                </span>
            </div>
            <form [formGroup]="Form" (ngSubmit)="OnSubmit()">
                <div>
                    <div class="tile-content">
                        <div class="radio-group-container">
                            <label class="label-question">Are you or any other member covered by another medical insurance policy?</label>
                            <app-toggle-confirm-dialog  #IsOtherInsuranceToggle
                                                        formControlName="IsOtherInsurance"
                                                        class="question-answer-input"
                                                        (Change)="HandleIsOtherInsuranceToggleEvent($event)"
                                                        [ShowConfirmDialogForNO]="false"
                                                        [ShowConfirmDialogForU]="false"
                                                        [ShowButtonU]="false"
                                                        [SkipModalWithEmit]="true"
                                                        [InputId]="'IsOtherInsuranceToggle'"
                                                        [InputName]="'IsOtherInsurance'">
                            </app-toggle-confirm-dialog>
                        </div>
                        <br>
                        <div *ngIf="ShowIsMedicare">
                        <div class="radio-group-container">
                            <label class="label-question">Are you or any other member covered by Medicare?</label>
                            <app-toggle-confirm-dialog  #IsMedicareToggle
                                                        formControlName="IsMedicare"
                                                        class="question-answer-input"
                                                        (Change)="HandleIsMedicareToggleEvent($event)"
                                                        [ShowConfirmDialogForNO]="false"
                                                        [ShowConfirmDialogForU]="false"
                                                        [ShowButtonU]="false"
                                                        [SkipModalWithEmit]="true"
                                                        [InputId]="'IsMedicareToggle'"
                                                        [InputName]="'IsMedicare'">
                            </app-toggle-confirm-dialog>
                        </div>
                    </div>
                        <br><br>
                        <div class="confirm-button-container" *ngIf="Form.valid">
                            <button mat-raised-button
                                type="submit"
                                class="mat-flat-button mat-primary btn-sm">
                                <mat-icon>arrow_forward_ios</mat-icon>
                                Next
                            </button>
                        </div>
                        <p class="confirm-footer-container">
                            <span>
                                The Web Questionnaire is not directed toward persons under 18 years of age. We do not knowingly market to or collect any personal information from children
                                under the age of 18 through the internet. If you are under 18, you are not permitted to submit any personal information to us through this site.
                                If you provide information to us through the Web Questionnaire, you represent that you are 18 years of age or older.
                            </span>
                        </p>
                    </div>
                </div>
            </form>
        </mat-card-content>
    </mat-card>
</div>
